<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">

                <div class="query-panel">
                    <el-form :inline="true">
                        <el-form-item label='角色'>
                            <el-select v-model="roleId" placeholder='请选择角色'>
                                <el-option :key="roleItem.id" v-for="roleItem in allRole" :label="roleItem.roleName" :value="roleItem.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getData()">查询用户</el-button>
                            <el-button type="danger" @click="createPopupShow = true">新增管理</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div v-show="adminList!=null">
                    <el-table :data="adminList" border style="width: 100%">
                        <el-table-column prop="id" label='id' width="100px"></el-table-column>
                        <el-table-column prop="name" label='名称' width="150px"></el-table-column>
                        <el-table-column prop="lastLogin" label='上次登录时间' width="150px"></el-table-column>
                        <el-table-column prop="account" label='帐号' width="100px"></el-table-column>
                        <el-table-column prop="remark" label='备注' width="200px">
                        </el-table-column>

                        <el-table-column label='操作'>
                            <template slot-scope="scope">
                                <template>
                                    <el-dropdown @command="changeRole">
                                    <span class="el-dropdown-link">
                                        修改权限
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="roleItem in allRole"
                                                              :key="roleItem.id"
                                                              :command="[scope.row.id, roleItem.id]"
                                                              :disabled="scope.row.roleId == roleItem.id">{{roleItem.roleName}}
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                                <el-button type="warning" @click="resetAction(scope.row.id)">密码重置</el-button>
                                <el-button type="danger" @click="deleteAction(scope.row.id)">账号清理</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </section>

            <!-- 创建 -->
            <el-dialog title='新增管理' :visible.sync="createPopupShow" width="30%" lock-scroll center @close="cancelCreate">
                <div>
                    <el-form ref="form" :model="createAdminForm" label-width="100px">
                        <el-form-item label='名称'>
                            <el-input v-model="createAdminForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label='账号'>
                            <el-input v-model="createAdminForm.account"></el-input>
                        </el-form-item>
                        <el-form-item label='密码'>
                            <el-tooltip effect="dark" content="随机生成密码" placement="right-start">
                                <el-input v-model="createAdminForm.passKey">
                                    <el-button slot="append" icon="el-icon-refresh" @click="randomCoding"></el-button>
                                </el-input>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label='备注'>
                            <el-input v-model="createAdminForm.remark"></el-input>
                        </el-form-item>
                        <el-form-item label='角色'>
                            <el-select v-model="createAdminForm.roleId" placeholder='选择管理员角色'>
                                <el-option v-for="roleItem in allRole" :label="roleItem.roleName" :key="roleItem.id" :value="roleItem.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='惯用语种'>
                            <el-select v-model="createAdminForm.lang" placeholder='选择语种'>
                                <el-option v-for="langItem in langType" :label="langItem.label" :key="langItem.value" :value="langItem.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancelCreate">取消</el-button>
                    <el-button type="primary" @click="submitCreate">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </el-card>
</template>

<script>
    import {
        mapState
    } from 'vuex';
    import adminApi from '../../service/admin_api'
    import actionConfirm from '../../mixins/action_confirm'
    import roleApi from "../../service/role_api";

    export default {
        data() {
            return {
                title: this.$route.meta.title,
                roleId: '',
                allRole:[],

                adminList: [],

                createPopupShow: false,
                createAdminForm: {
                    account: '',
                    name: '',
                    passKey: '',
                    remark: '',
                    roleId: '',
                    lang: ''
                }
            }
        },
        mixins: [actionConfirm],
        mounted() {},
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                lang: state => state.user.userInfo.lang,
            }),
        },
        created() {
            this.getAllRole();
            this.getLangs();
        },
        methods: {
            randomCoding(){
                var result = [];
                var  n = 8;
                for(var i=0;i<n;i++){
                    var ranNum = Math.ceil(Math.random() * 25);
                    result.push(String.fromCharCode(65+ranNum));
                }
                this.createAdminForm.passKey = result.join('');
            },

            getAllRole(){
                let self = this;
                roleApi.allRole({
                    token: self.token
                }).then(res=>{
                    self.allRole = res;
                })
            },
            // 获取管理员数据
            getData() {
                let roleId = this.roleId;
                let token = this.token;
                if (roleId) {
                    adminApi.findByRoleId({
                        roleId,
                        token
                    }).then(res => {
                        this.adminList = res;
                    })
                }
            },
            // 修改权限
            changeRole(e) {
                var gameAdminId = e[0],
                    roleId = e[1],
                    token = this.token;
                adminApi.changeAdminRole({
                    gameAdminId,
                    roleId,
                    token
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.getData();
                })
            },

            // 创建管理员
            submitCreate() {
                adminApi.createAdmin({
                    adminSaveForm: this.createAdminForm,
                    token: this.token
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '创建成功'
                    });
                    this.createPopupShow = false;
                    this.getData();
                })
            },

            // 取消创建
            cancelCreate() {
                this.createAdminForm = {
                    account: '',
                    name: '',
                    passKey: '',
                    remark: '',
                    roleId: '',
                    lang: ''
                }
                this.createPopupShow = false;
            },
            resetAction(id){
                this.$prompt('此操作将该管理员密码重置，请输入操作备注', '密码重置', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator: (str) => {
                        return str != null
                    },
                    inputErrorMessage: '请输入操作备注'
                }).then(({
                             value
                         }) => {
                    adminApi.resetPassword({
                        resetForm: {
                            id: id,
                            remark: value
                        },
                        token: this.token
                    }).then(res => {
                        this.$alert(res, '密码重置成功', {
                            confirmButtonText: '确定',
                            callback: action => {
                            }
                        });
                        this.getData();
                    })
                }).catch(() => {

                });
            },
            // 删除管理员
            deleteAction(id) {
                this.$prompt('此操作将删除该管理员，请输入操作备注', '删除用户', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator: (str) => {
                        return str != null
                    },
                    inputErrorMessage: '请输入操作备注'
                }).then(({
                    value
                }) => {
                    adminApi.removeAdmin({
                        removeAdminBO: {
                            id: id,
                            remark: value
                        },
                        token: this.token
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getData();
                    })
                }).catch(() => {

                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/dev_tools/admins.vue